var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlusFilledBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.681,
    height: 27.681,
    viewBox: "0 0 27.681 27.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_78a1f1737f695f72fe836b7e695a4959",
    "data-name": "78a1f1737f695f72fe836b7e695a4959",
    d: "M22.05,8.21a13.84,13.84,0,1,0,13.84,13.84A13.84,13.84,0,0,0,22.05,8.21Zm5.4,14.713H22.923v4.532a.873.873,0,0,1-1.745,0V22.923H16.646a.873.873,0,1,1,0-1.745h4.532V16.646a.873.873,0,1,1,1.745,0v4.532h4.532a.873.873,0,1,1,0,1.745Z",
    transform: "translate(-8.21 -8.21)",
    fill: "#222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusFilledBlack);
export default __webpack_public_path__ + "static/media/CirclePlusFilledBlack.91ba812ba234783367d1d1f8733a416f.svg";
export { ForwardRef as ReactComponent };